import * as types from "./ActionType";
import { instance, multipartInstance } from "../BaseUrl/BaseUrl";
import { handleErrors } from "../Utils/util";
import { toast } from "react-hot-toast";
import {
	createAction,
	deleteItem,
	fetchData,
	getOneItem,
	fetchDataNoPag,
	updateStatus,
} from "../Api/endpoint";
// import { handleImageUpload } from "../Utils/uoloadImgToS3";

// SIGNIN
export const signInSuccess = (Token) => ({
	type: types.SIGN_IN,
	payload: Token,
});

const getProfileSuccess = (Profile) => ({
	type: types.GET_PROFILE,
	payload: Profile,
});

// // Example usage for "Place"
const getPlacesSuccess = createAction(types.GET_ALL_PLACE, (Place) => Place);

const getTransactionPlacesSuccess = createAction(
	types.GET_ALL_TRANSACTION_PLACE,
	(TransactionPlace) => TransactionPlace
);

const getOnePlaceSuccess = createAction(
	types.GET_ONE_PLACE,
	(onePlace) => onePlace
);

export const clearOnePlace = () => ({
	type: types.CLEAR_ONE_PLACE,
});

const addPlaceSuccess = createAction(types.SET_PLACE, (Place) => Place);

const updatePlaceSuccess = (PlaceId, UpdatedPlace) => ({
	type: types.UPDATE_PLACE,
	payload: { PlaceId, UpdatedPlace },
});
const deletePlaceSuccess = createAction(types.DELETE_PLACE, (PlaceId) => ({
	PlaceId,
}));

const getPlaceImageSuccess = createAction(
	types.GET_ALL_PLACE_IMAGE,
	(PlaceImage) => PlaceImage
);

const addPlaceImageSuccess = createAction(
	types.SET_PLACE_IMAGE,
	(PlaceImage) => PlaceImage
);

const deletePlaceImageSuccess = createAction(
	types.DELETE_PLACE_IMAGE,
	(PlaceImageId) => ({
		PlaceImageId,
	})
);

const getPlaceVideoSuccess = createAction(
	types.GET_ALL_PLACE_VIDEO,
	(PlaceVideo) => PlaceVideo
);

const addPlaceVideoSuccess = createAction(
	types.SET_PLACE_VIDEO,
	(PlaceVideo) => PlaceVideo
);

const deletePlaceVideoSuccess = createAction(
	types.DELETE_PLACE_VIDEO,
	(PlaceVideoId) => ({
		PlaceVideoId,
	})
);

const getPlaceReelsSuccess = createAction(
	types.GET_ALL_PLACE_REELS,
	(PlaceReels) => PlaceReels
);

const addPlaceReelsSuccess = createAction(
	types.SET_PLACE_REELS,
	(PlaceReels) => PlaceReels
);

const deletePlaceReelsSuccess = createAction(
	types.DELETE_PLACE_REELS,
	(PlaceReelsId) => ({
		PlaceReelsId,
	})
);

const getPackageImageSuccess = createAction(
	types.GET_ALL_PACKAGE_IMAGE,
	(PackageImage) => PackageImage
);

const addPackageImageSuccess = createAction(
	types.SET_PACKAGE_IMAGE,
	(PackageImage) => PackageImage
);

const deletePackageImageSuccess = createAction(
	types.DELETE_PACKAGE_IMAGE,
	(PackageImageId) => ({
		PackageImageId,
	})
);

const getPackageVideoSuccess = createAction(
	types.GET_ALL_PACKAGE_VIDEO,
	(PackageVideo) => PackageVideo
);

const addPackageVideoSuccess = createAction(
	types.SET_PACKAGE_VIDEO,
	(PackageVideo) => PackageVideo
);

const deletePackageVideoSuccess = createAction(
	types.DELETE_PACKAGE_VIDEO,
	(PackageVideoId) => ({
		PackageVideoId,
	})
);

const getPackageReelsSuccess = createAction(
	types.GET_ALL_PACKAGE_REELS,
	(PackageReels) => PackageReels
);

const addPackageReelsSuccess = createAction(
	types.SET_PACKAGE_REELS,
	(PackageReels) => PackageReels
);

const deletePackageReelsSuccess = createAction(
	types.DELETE_PACKAGE_REELS,
	(PackageReelsId) => ({
		PackageReelsId,
	})
);

const getOneSiteSettingSuccess = createAction(
	types.GET_ONE_SITE_SETTING,
	(oneSiteSetting) => oneSiteSetting
);

const getOneHotelSettingSuccess = createAction(
	types.GET_ONE_HOTEL_SETTING,
	(oneHotelSetting) => oneHotelSetting
);

// ------------- SignIn -API ------------- //
export const SignInAdmin = (email, password, navigate) => {
	return async function (dispatch) {
		try {
			const dataResult = await instance.post("/auth/login", {
				email,
				password,
			});
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, message, status } = result;
				if (status) {
					toast.success(message);
					dispatch(signInSuccess(data));
					localStorage.setItem(
						"user",
						JSON.stringify({
							Token: data.accessToken,
							email: data.userEmail,
							role: data.role,
							name: data.userName,
							staffId: data.userId,
							access: data.access,
						})
					);
					navigate("/");
				} else {
					console.log("An error occurred, Please retry again");
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getProfile = (navigate) => {
	return async function (dispatch) {
		try {
			const dataResult = await instance.get("/user/get-profile");
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status } = result;
				if (status) {
					dispatch(getProfileSuccess(data));
					const userData = JSON.parse(localStorage.getItem("user"));
					userData.access = data.staffAccess;
					localStorage.setItem("user", JSON.stringify(userData));
				} else {
					localStorage?.clear();
					navigate("/login");
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

const getPlaceOnSettingSuccess = createAction(
	types.GET_ALL_PLACE_ON_SETTING,
	(PlaceOnSetting) => PlaceOnSetting
);
const addPlaceOnSettingSuccess = createAction(
	types.SET_ALL_PLACE_ON_SETTING,
	(PlaceOnSetting) => PlaceOnSetting
);
const deletePlaceOnSettingSuccess = createAction(
	types.DELETE_PLACE_ON_SETTING,
	(PlaceOnSettingId) => ({
		PlaceOnSettingId,
	})
);

const getPlaceOffSettingSuccess = createAction(
	types.GET_ALL_PLACE_OFF_SETTING,
	(PlaceOffSetting) => PlaceOffSetting
);
const addPlaceOffSettingSuccess = createAction(
	types.SET_ALL_PLACE_OFF_SETTING,
	(PlaceOffSetting) => PlaceOffSetting
);
const deletePlaceOffSettingSuccess = createAction(
	types.DELETE_PLACE_OFF_SETTING,
	(PlaceOffSettingId) => ({
		PlaceOffSettingId,
	})
);

const getPackageCategorySuccess = createAction(
	types.GET_ALL_PACKAGE_CATEGORY,
	(PackageCategory) => PackageCategory
);

const getOnePackageCategorysuccess = createAction(
	types.GET_ONE_PACKAGE_CATEGORY,
	(onePackageCategory) => onePackageCategory
);

export const clearPackageCategory = () => ({
	type: types.CLEAR_PACKAGE_CATEGORY,
});

const addPackageCategorysuccess = createAction(
	types.SET_PACKAGE_CATEGORY,
	(PackageCategory) => PackageCategory
);

const updatePackageCategorysuccess = (
	PackageCategoryId,
	UpdatedPackageCategory
) => ({
	type: types.UPDATE_PACKAGE_CATEGORY,
	payload: { PackageCategoryId, UpdatedPackageCategory },
});
const deletePackageCategorysuccess = createAction(
	types.DELETE_PACKAGE_CATEGORY,
	(PackageCategoryId) => ({
		PackageCategoryId,
	})
);

const getPackageSuccess = createAction(
	types.GET_ALL_PACKAGE,
	(Package) => Package
);

const getOnePackageSuccess = createAction(
	types.GET_ONE_PACKAGE,
	(onePackage) => onePackage
);

export const clearOnePackage = () => ({
	type: types.CLEAR_ONE_PACKAGE,
});

const addPackageSuccess = createAction(types.SET_PACKAGE, (Package) => Package);

const updatePackageSuccess = (PackageId, UpdatedPackage) => ({
	type: types.UPDATE_PACKAGE,
	payload: { PackageId, UpdatedPackage },
});
const deletePackageSuccess = createAction(
	types.DELETE_PACKAGE,
	(PackageId) => ({
		PackageId,
	})
);

const getBookingSuccess = createAction(
	types.GET_ALL_BOOKINGS,
	(BookingList) => BookingList
);

const getPackageBookingSuccess = createAction(
	types.GET_ALL_PACKAGE_BOOKINGS,
	(PackageBookingList) => PackageBookingList
);

const getOneBookingSuccess = createAction(
	types.GET_ONE_BOOKING,
	(oneBooking) => oneBooking
);

const getBookingPaymentSuccess = createAction(
	types.GET_BOOKING_PAYMENT,
	(bookingPayment) => bookingPayment
);

const updateBookingSuccess = (BookingId, UpdatedBookingList) => ({
	type: types.UPDATE_BOOKING,
	payload: { BookingId, UpdatedBookingList },
});

export const clearOneBooking = () => ({
	type: types.CLEAR_ONE_BOOKING,
});

const getPendingRazorpaySettlementSuccess = createAction(
	types.GET_PENDING_RAZORPAY_SETTLEMENT,
	(PendingRazorpaySettlement) => PendingRazorpaySettlement
);

const getAttractionBookingCountSuccess = createAction(
	types.GET_ATTRACTION_BOOKING_COUNT,
	(attractionBookingCount) => attractionBookingCount
);

const getPackageBookingCountSuccess = createAction(
	types.GET_PACKAGE_BOOKING_COUNT,
	(packageBookingCount) => packageBookingCount
);

const bookingMoveToRefundSuccess = createAction(
	types.MOVE_BOOKING,
	(BookingId) => ({
		BookingId,
	})
);

const getTeamSuccess = createAction(types.GET_ALL_TEAM, (Team) => Team);

const getOneTeamSuccess = createAction(
	types.GET_ONE_TEAM,
	(oneTeam) => oneTeam
);

export const clearOneTeam = () => ({
	type: types.CLEAR_ONE_TEAM,
});

const addTeamSuccess = createAction(types.SET_TEAM, (Team) => Team);

const updateTeamSuccess = (TeamId, UpdatedTeam) => ({
	type: types.UPDATE_TEAM,
	payload: { TeamId, UpdatedTeam },
});
const deleteTeamSuccess = createAction(types.DELETE_TEAM, (TeamId) => ({
	TeamId,
}));

const getTeamAttendanceSuccess = createAction(
	types.GET_TEAM_ATTENDANCE,
	(TeamAttendance) => TeamAttendance
);

const addTeamAttendanceSuccess = createAction(
	types.SET_TEAM_ATTENDANCE,
	(TeamAttendance) => TeamAttendance
);

const updateTeamAttendanceSuccess = (
	TeamAttendanceId,
	UpdatedTeamAttendance
) => ({
	type: types.UPDATE_TEAM,
	payload: { TeamAttendanceId, UpdatedTeamAttendance },
});

const getOneTeamAttendanceSuccess = createAction(
	types.GET_ONE_TEAM_ATTENDANCE,
	(oneTeamAttendance) => oneTeamAttendance
);

export const clearOneTeamAttendance = () => ({
	type: types.CLEAR_ONE_TEAM_ATTENDANCE,
});

const getTeamTeamSalaryReportSuccess = createAction(
	types.GET_TEAM_SEALERY_REPORT,
	(TeamSalaryReport) => TeamSalaryReport
);

const getBankAccountSuccess = createAction(
	types.GET_ALL_BANK_ACCOUNT,
	(BankAccount) => BankAccount
);

const getOneBankAccountSuccess = createAction(
	types.GET_ONE_BANK_ACCOUNT,
	(oneBankAccount) => oneBankAccount
);

export const clearOneBankAccount = () => ({
	type: types.CLEAR_ONE_BANK_ACCOUNT,
});

const addBankAccountSuccess = createAction(
	types.SET_BANK_ACCOUNT,
	(BankAccount) => BankAccount
);

const updateBankAccountSuccess = (BankAccountId, UpdatedBankAccount) => ({
	type: types.UPDATE_BANK_ACCOUNT,
	payload: { BankAccountId, UpdatedBankAccount },
});
const deleteBankAccountSuccess = createAction(
	types.DELETE_BANK_ACCOUNT,
	(BankAccountId) => ({
		BankAccountId,
	})
);

const getCreditCardSuccess = createAction(
	types.GET_ALL_CREDIT_CARD,
	(CreditCard) => CreditCard
);

const getOneCreditCardSuccess = createAction(
	types.GET_ONE_CREDIT_CARD,
	(oneCreditCard) => oneCreditCard
);

export const clearOneCreditCard = () => ({
	type: types.CLEAR_ONE_CREDIT_CARD,
});

const addCreditCardSuccess = createAction(
	types.SET_CREDIT_CARD,
	(CreditCard) => CreditCard
);

const updateCreditCardSuccess = (CreditCardId, UpdatedCreditCard) => ({
	type: types.UPDATE_CREDIT_CARD,
	payload: { CreditCardId, UpdatedCreditCard },
});
const deleteCreditCardSuccess = createAction(
	types.DELETE_CREDIT_CARD,
	(CreditCardId) => ({
		CreditCardId,
	})
);

const getCurrentBalanceTotalSuccess = createAction(
	types.GET_CURRENT_BALANCE_TOTAL,
	(CurrentBalanceTotal) => CurrentBalanceTotal
);

const getDebitNoteSuccess = createAction(
	types.GET_ALL_DEBIT_NOTE,
	(DebitNote) => DebitNote
);

const getOneDebitNoteSuccess = createAction(
	types.GET_ONE_DEBIT_NOTE,
	(oneDebitNote) => oneDebitNote
);

export const clearOneDebitNote = () => ({
	type: types.CLEAR_ONE_DEBIT_NOTE,
});

const addDebitNoteSuccess = createAction(
	types.SET_DEBIT_NOTE,
	(DebitNote) => DebitNote
);

const updateDebitNoteSuccess = (DebitNoteId, UpdatedDebitNote) => ({
	type: types.UPDATE_DEBIT_NOTE,
	payload: { DebitNoteId, UpdatedDebitNote },
});
const deleteDebitNoteSuccess = createAction(
	types.DELETE_DEBIT_NOTE,
	(DebitNoteId) => ({
		DebitNoteId,
	})
);

const getCreditNoteSuccess = createAction(
	types.GET_ALL_CREDIT_NOTE,
	(CreditNote) => CreditNote
);

const getOneCreditNoteSuccess = createAction(
	types.GET_ONE_CREDIT_NOTE,
	(oneCreditNote) => oneCreditNote
);

export const clearOneCreditNote = () => ({
	type: types.CLEAR_ONE_CREDIT_NOTE,
});

const addCreditNoteSuccess = createAction(
	types.SET_CREDIT_NOTE,
	(CreditNote) => CreditNote
);

const updateCreditNoteSuccess = (CreditNoteId, UpdatedCreditNote) => ({
	type: types.UPDATE_CREDIT_NOTE,
	payload: { CreditNoteId, UpdatedCreditNote },
});
const deleteCreditNoteSuccess = createAction(
	types.DELETE_CREDIT_NOTE,
	(CreditNoteId) => ({
		CreditNoteId,
	})
);

const getCrDrTotalSuccess = createAction(
	types.GET_CR_DR_TOTAL,
	(CrDrTotal) => CrDrTotal
);

const getSalesSuccess = createAction(
	types.GET_ALL_SALES,
	(Sales) => Sales
);

const getPurchaseSuccess = createAction(
	types.GET_ALL_PURCHASE,
	(Purchase) => Purchase
);

const getHomeBannerSuccess = createAction(
	types.GET_ALL_HOME_BANNER,
	(HomeBanner) => HomeBanner
);

const getOneHomeBannerSuccess = createAction(
	types.GET_ONE_HOME_BANNER,
	(oneHomeBanner) => oneHomeBanner
);

const addHomeBannerSuccess = createAction(
	types.SET_HOME_BANNER,
	(HomeBanner) => HomeBanner
);

const updateHomeBannerSuccess = (HomeBannerId, UpdatedHomeBanner) => ({
	type: types.UPDATE_HOME_BANNER,
	payload: { HomeBannerId, UpdatedHomeBanner },
});
const deleteHomeBannerSuccess = createAction(
	types.DELETE_HOME_BANNER,
	(HomeBannerId) => ({
		HomeBannerId,
	})
);

const getHomePlaceSuccess = createAction(
	types.GET_ALL_HOME_PLACE,
	(HomePlace) => HomePlace
);

const getOneHomePlaceSuccess = createAction(
	types.GET_ONE_HOME_PLACE,
	(oneHomePlace) => oneHomePlace
);

const addHomePlaceSuccess = createAction(
	types.SET_HOME_PLACE,
	(HomePlace) => HomePlace
);

const updateHomePlaceSuccess = (HomePlaceId, UpdatedHomePlace) => ({
	type: types.UPDATE_HOME_PLACE,
	payload: { HomePlaceId, UpdatedHomePlace },
});
const deleteHomePlaceSuccess = createAction(
	types.DELETE_HOME_PLACE,
	(HomePlaceId) => ({
		HomePlaceId,
	})
);

const getPhoneNumberSuccess = createAction(
	types.GET_ALL_SOU_NUMBER,
	(PhoneNumber) => PhoneNumber
);

const getOnePhoneNumberSuccess = createAction(
	types.GET_ONE_SOU_NUMBER,
	(onePhoneNumber) => onePhoneNumber
);

const addPhoneNumberSuccess = createAction(
	types.SET_SOU_NUMBER,
	(PhoneNumber) => PhoneNumber
);

const updatePhoneNumberSuccess = (PhoneNumberId, UpdatedPhoneNumber) => ({
	type: types.UPDATE_SOU_NUMBER,
	payload: { PhoneNumberId, UpdatedPhoneNumber },
});
const deletePhoneNumberSuccess = createAction(
	types.DELETE_SOU_NUMBER,
	(PhoneNumberId) => ({
		PhoneNumberId,
	})
);

const getBankAccessSuccess = createAction(
	types.GET_ALL_BANK_ACCESS,
	(BankAccess) => BankAccess
);

const addBankAccessSuccess = createAction(
	types.SET_BANK_ACCESS,
	(BankAccess) => BankAccess
);

const updateBankAccessSuccess = (BankAccessId, UpdatedBankAccess) => ({
	type: types.UPDATE_BANK_ACCESS,
	payload: { BankAccessId, UpdatedBankAccess },
});

const getDashboardDataSuccess = createAction(
	types.GET_DASHBOARD_DATA,
	(DashboardData) => DashboardData
);

const getDashboardOtherDataSuccess = createAction(
	types.GET_DASHBOARD_OTHER_DATA,
	(DashboardOtherData) => DashboardOtherData
);

const getPaymentHistorySuccess = createAction(
	types.GET_PAYMENT_HISTORY,
	(PaymentHistory) => PaymentHistory
);

const getDailyLedgerSuccess = createAction(
	types.GET_DAILY_LEDGER,
	(DailyLedger) => DailyLedger
);

const getAccessKeysSuccess = createAction(
	types.GET_ACCESS_KEYS,
	(AccessKeys) => AccessKeys
);

const getBankTransferSuccess = createAction(
	types.GET_ALL_BANK_TRANSFER,
	(BankTransfer) => BankTransfer
);

const addBankTransferSuccess = createAction(
	types.SET_BANK_TRANSFER,
	(BankTransfer) => BankTransfer
);

const getNumberAccessSuccess = createAction(
	types.GET_ALL_NUMBER_ACCESS,
	(NumberAccess) => NumberAccess
);

const addNumberAccessSuccess = createAction(
	types.SET_NUMBER_ACCESS,
	(NumberAccess) => NumberAccess
);

const updateNumberAccessSuccess = (NumberAccessId, UpdatedNumberAccess) => ({
	type: types.UPDATE_NUMBER_ACCESS,
	payload: { NumberAccessId, UpdatedNumberAccess },
});

const getCountriesSuccess = createAction(
	types.GET_ALL_COUNTRIES,
	(Countries) => Countries
);
const getStatesSuccess = createAction(types.GET_ALL_STATES, (States) => States);

const getQuotationSuccess = createAction(
	types.GET_ALL_QUOTATION,
	(Quotation) => Quotation
);

const getOneQuotationSuccess = createAction(
	types.GET_ONE_QUOTATION,
	(oneQuotation) => oneQuotation
);

export const clearOneQuotation = () => ({
	type: types.CLEAR_ONE_QUOTATION,
});

const addQuotationSuccess = createAction(
	types.SET_QUOTATION,
	(Quotation) => Quotation
);

const updateQuotationSuccess = (QuotationId, UpdatedQuotation) => ({
	type: types.UPDATE_QUOTATION,
	payload: { QuotationId, UpdatedQuotation },
});
// const deleteQuotationSuccess = createAction(types.DELETE_QUOTATION, (QuotationId) => ({
// 	QuotationId,
// }));

const getVisitorSuccess = createAction(
	types.GET_ALL_VISITOR,
	(Visitor) => Visitor
);
const addVisitorSuccess = createAction(
	types.SET_ALL_VISITOR,
	(Visitor) => Visitor
);
const updateVisitorSuccess = (VisitorId, UpdatedVisitor) => ({
	type: types.UPDATE_VISITOR,
	payload: { VisitorId, UpdatedVisitor },
});
const deleteVisitorSuccess = createAction(
	types.DELETE_VISITOR,
	(VisitorId) => ({
		VisitorId,
	})
);

const getTeamBankReportSuccess = createAction(
	types.GET_TEAM_BANK_REPORT,
	(TeamBankReport) => TeamBankReport
);

const getStaffSalesReportSuccess = createAction(
	types.GET_TEAM_SALES_REPORT,
	(StaffSalesReport) => StaffSalesReport
);
const getStaffSalesDataSuccess = createAction(
	types.GET_TEAM_SALES_DATA,
	(StaffSalesData) => StaffSalesData
);

const getEnquirySuccess = createAction(
	types.GET_ALL_ENQUIRY,
	(Enquiry) => Enquiry
);

export const clearOneEnquiry = () => ({
	type: types.CLEAR_ONE_ENQUIRY,
});

// const updateEnquirySuccess = (EnquiryId, UpdatedEnquiry) => ({
// 	type: types.UPDATE_ENQUIRY,
// 	payload: { EnquiryId, UpdatedEnquiry },
// });

const deleteEnquirySuccess = createAction(types.DELETE_ENQUIRY, (EnquiryId) => ({
	EnquiryId,
}));

const getPlaceBookingOffSettingSuccess = createAction(
	types.GET_PLACE_BOOKING_OFF_SETTING,
	(PlaceBookingOffSetting) => PlaceBookingOffSetting
);
const addPlaceBookingOffSettingSuccess = createAction(
	types.SET_PLACE_BOOKING_OFF_SETTING,
	(PlaceBookingOffSetting) => PlaceBookingOffSetting
);
const deletePlaceBookingOffSettingSuccess = createAction(
	types.DELETE_PLACE_BOOKING_OFF_SETTING,
	(PlaceBookingOffSettingId) => ({
		PlaceBookingOffSettingId,
	})
);

const getOneHomePageNoteSuccess = createAction(
	types.GET_ONE_HOME_NOTE,
	(homeNote) => homeNote
);

const getPlaceKeySuccess = createAction(
	types.GET_ALL_SOU_PLACE_KEY,
	(PlaceKeys) => PlaceKeys
);

const getFaqSuccess = createAction(types.GET_ALL_FAQ, (Faq) => Faq);

const getOneFaqSuccess = createAction(types.GET_ONE_FAQ, (oneFaq) => oneFaq);

const addFaqSuccess = createAction(types.SET_FAQ, (Faq) => Faq);

const updateFaqSuccess = (FaqId, UpdatedFaq) => ({
	type: types.UPDATE_FAQ,
	payload: { FaqId, UpdatedFaq },
});
const deleteFaqSuccess = createAction(types.DELETE_FAQ, (FaqId) => ({
	FaqId,
}));

const getWarningMessageSuccess = createAction(
	types.GET_WARNING_MESSAGE,
	(warningMessage) => warningMessage
);

const getAvailableTicketSuccess = createAction(
	types.GET_AVAILABLE_TICKETS,
	(AvailableTicket) => AvailableTicket
);

export const updateAvailableTicketSuccess = (
	AvailableTicketId,
	UpdatedAvailableTicket
) => ({
	type: types.UPDATE_AVAILABLE_TICKETS,
	payload: { AvailableTicketId, UpdatedAvailableTicket },
});

const getNotificationCountSuccess = createAction(
	types.GET_NOTIFICATION_COUNT,
	(notificationCount) => notificationCount
);

const getNotificationSuccess = createAction(
	types.GET_ALL_NOTIFICATION,
	(AllNotification) => AllNotification
);

const getHotelSuccess = createAction(
	types.GET_ALL_HOTEL,
	(AllHotel) => AllHotel
);

const getTestimonialSuccess = createAction(types.GET_ALL_TESTIMONIAL, (Testimonial) => Testimonial);

const getOneTestimonialSuccess = createAction(types.GET_ONE_TESTIMONIAL, (oneTestimonial) => oneTestimonial);

const addTestimonialSuccess = createAction(types.SET_TESTIMONIAL, (Testimonial) => Testimonial);

const updateTestimonialSuccess = (TestimonialId, UpdatedTestimonial) => ({
	type: types.UPDATE_TESTIMONIAL,
	payload: { TestimonialId, UpdatedTestimonial },
});
const deleteTestimonialSuccess = createAction(types.DELETE_TESTIMONIAL, (TestimonialId) => ({
	TestimonialId,
}));

const getSalesReportSuccess = createAction(types.GET_SALES_REPORT, (SalesReport) => SalesReport);
const getSalesReportExportSuccess = createAction(types.GET_SALES_REPORT_EXPORT, (SalesReportExport) => SalesReportExport);
const getSalesReportTotalSuccess = createAction(types.GET_SALES_REPORT_TOTAL, (SalesReportTotal) => SalesReportTotal);

const getPurchaseReportSuccess = createAction(types.GET_PURCHASE_REPORT, (PurchaseReport) => PurchaseReport);
const getPurchaseReportExportSuccess = createAction(types.GET_PURCHASE_REPORT_EXPORT, (PurchaseReportExport) => PurchaseReportExport);
const getPurchaseReportTotalSuccess = createAction(types.GET_PURCHASE_REPORT_TOTAL, (PurchaseReportTotal) => PurchaseReportTotal);

const getCommissionReportSuccess = createAction(types.GET_COMMISSION_REPORT, (CommissionReport) => CommissionReport);
const getCommissionReportExportSuccess = createAction(types.GET_COMMISSION_REPORT_EXPORT, (CommissionReportExport) => CommissionReportExport);
const getCommissionReportTotalSuccess = createAction(types.GET_COMMISSION_REPORT_TOTAL, (CommissionReportTotal) => CommissionReportTotal);

const getCancelReportSuccess = createAction(types.GET_CANCEL_REPORT, (CancelReport) => CancelReport);
const getCancelReportExportSuccess = createAction(types.GET_CANCEL_REPORT_EXPORT, (CancelReportExport) => CancelReportExport);
const getCancelReportTotalSuccess = createAction(types.GET_CANCEL_REPORT_TOTAL, (CancelReportTotal) => CancelReportTotal);

const getAttractionReportSuccess = createAction(types.GET_ATTRACTION_REPORT, (AttractionReport) => AttractionReport);
const getAttractionReportExportSuccess = createAction(types.GET_ATTRACTION_REPORT_EXPORT, (AttractionReportExport) => AttractionReportExport);
const getAttractionReportTotalSuccess = createAction(types.GET_ATTRACTION_REPORT_TOTAL, (AttractionReportTotal) => AttractionReportTotal);

const getGstReportSuccess = createAction(types.GET_GST_REPORT, (GstReport) => GstReport);
const getGstReportExportSuccess = createAction(types.GET_GST_REPORT_EXPORT, (GstReportExport) => GstReportExport);
const getGstReportTotalSuccess = createAction(types.GET_GST_REPORT_TOTAL, (GstReportTotal) => GstReportTotal);

const getBookingForReviewSuccess = createAction(types.GET_BOOKING_FOR_REVIEW, (BookingForReview) => BookingForReview);

const getStaffBankDetailDataSuccess = createAction(
	types.GET_TEAM_BANK_REPORT_DATA,
	(StaffBankDetailData) => StaffBankDetailData
);

// Common function to upload image
export const uploadImage = async (
	itemId,
	formDataState,
	type,
	folder = "image",
	subFolder = "",
	uploadModule = "",
	navigationUrl = "",
	navigate
) => {
	try {
		const formData = new FormData();
		formData.append("type", type);
		formData.append("folder", folder);
		formData.append("subFolder", subFolder);
		formData.append("uploadModule", uploadModule);
		formData.append("files", formDataState.images);

		const dataResult = await multipartInstance.put(
			`/common/upload/gallery/${itemId}`,
			formData,
			{
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}
		);
		const { status, message } = dataResult.data;
		if (status) {
			navigate(navigationUrl);
			toast.success(message);
		} else {
			toast.error(message);
		}
	} catch (err) {
		console.log(err);
		handleErrors(err);
	}
};

/* Get All Places */
export const getPlaces = fetchData("place/getAll", getPlacesSuccess);

export const getAllPlaces = fetchDataNoPag(
	"place/getAllPlace",
	getPlacesSuccess
);

export const getTransactionPlace = fetchDataNoPag(
	"place/get-transportation-places",
	getTransactionPlacesSuccess
);

/* Get One Place */
export const getOnePlace = getOneItem("place", getOnePlaceSuccess);

/* Add one Place*/
export const setPlace = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/place/addPlace",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					navigate("/tourist-places");
					toast.success(message);
					dispatch(addPlaceSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

/* Update one Place*/
export const updatePlace = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/place/update/${_id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/tourist-places");
					toast.success(message);
					dispatch(updatePlaceSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deletePlaceBannerImage = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/place/delete-banner-image/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updatePlaceSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

/* Update one Place*/
export const updatePlaceStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/place/update-place-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updatePlaceSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

// /* Delete one Place */
export const deletePlace = deleteItem("place", deletePlaceSuccess);

export const setPlaceSortOrder = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put("/place/setSortOrder", formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPlacesSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPlaceImage = (_id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/place/allImages/" + _id);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPlaceImageSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setPlaceImages = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/place/upload-images/" + _id,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addPlaceImageSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPlaceVideo = (_id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/place/allVideos/" + _id);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPlaceVideoSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setPlaceVideo = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/place/upload-videos/" + _id,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addPlaceVideoSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPlaceReels = (_id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/place/allReels/" + _id);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPlaceReelsSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setPlaceReels = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/place/upload-reels/" + _id,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addPlaceReelsSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deletePlaceGalleryItem = (_id, type) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/place/remove-gallery/" + _id + "?type=" + type
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, message } = result;
				if (status) {
					toast.success(message);
					if (type === "image") {
						dispatch(deletePlaceImageSuccess(_id));
					} else if (type === "video") {
						dispatch(deletePlaceVideoSuccess(_id));
					} else {
						dispatch(deletePlaceReelsSuccess(_id));
					}
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

/* Get All Place On Setting */
export const getPlaceOnSetting = fetchData(
	"place/get-all-on-settings",
	getPlaceOnSettingSuccess
);

export const setPlaceOnSetting = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post("/place/add-on-setting", formData);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					dispatch(addPlaceOnSettingSuccess(data));
					navigate("/place/on");
					toast.success(message);
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deletePlaceOnSetting = deleteItem(
	"place/place-on-setting",
	deletePlaceOnSettingSuccess
);

export const getPlaceOffSetting = fetchData(
	"place/get-all-off-settings",
	getPlaceOffSettingSuccess
);

export const setPlaceOffSetting = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/place/add-off-setting",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					dispatch(addPlaceOffSettingSuccess(data));
					navigate("/place/off");
					toast.success(message);
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deletePlaceOffSetting = deleteItem(
	"place/place-off-setting",
	deletePlaceOffSettingSuccess
);

/* Get All Package Category */
export const getPackageCategory = fetchData(
	"category/getall",
	getPackageCategorySuccess
);

export const getAllPackageCategory = fetchDataNoPag(
	"category/allCategory",
	getPackageCategorySuccess
);

/* Get One Package Category */
export const getOnePackageCategory = getOneItem(
	"category",
	getOnePackageCategorysuccess
);

/* Add one Package Category*/
export const setPackageCategory = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/category/add",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					navigate("/package/category");
					toast.success(message);
					dispatch(addPackageCategorysuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

/* Update one Package Category*/
export const updatePackageCategory = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/category/update/${_id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/package/category");
					toast.success(message);
					dispatch(updatePackageCategorysuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

/* Update one Place*/
export const updatePackageCategoryStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/category/update-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updatePackageCategorysuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deletePackageCategory = deleteItem(
	"category",
	deletePackageCategorysuccess
);

/* Get All Package  */
export const getPackage = fetchData("package/getall", getPackageSuccess);

export const getAllPackages = fetchDataNoPag(
	"package/getAllPackage",
	getPackageSuccess
);

/* Get One Package  */
export const getOnePackage = getOneItem("package", getOnePackageSuccess);

/* Add one Package */
export const setPackage = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/package/add",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					navigate("/package");
					toast.success(message);
					dispatch(addPackageSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

/* Update one Package*/
export const updatePackage = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/package/update/${_id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/package");
					toast.success(message);
					dispatch(updatePackageSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deletePackageBannerImage = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/package/delete-banner-image/${_id}`,
				formData
			);
			const { status, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					// dispatch(updatePlaceSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

/* Update one Place*/
export const updatePackageStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/package/update-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updatePackageSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

// /* Delete one Place */
export const deletePackage = deleteItem("package", deletePackageSuccess);

export const getBookings = fetchData("booking/getall", getBookingSuccess);
export const getBookingHistory = fetchData(
	"booking/getBookingHistory",
	getBookingSuccess
);
export const getPendingSettlement = fetchData(
	"booking/getPendingSettlement",
	getBookingSuccess
);

export const getProgressSettlement = fetchData(
	"booking/getProgressSettlement",
	getBookingSuccess
);
export const getOneBooking = getOneItem("booking", getOneBookingSuccess);
export const getBookingPayment = (_id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				`/booking/getPaymentDetail/${_id}`,
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					dispatch(getBookingPaymentSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};
export const confirmBooking = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/booking/confirm/${_id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const souCancelBooking = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/booking/soucancel/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const cancelBooking = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/booking/cancel/${_id}`, formData);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const uploadSOUCancelScreenshot = (BookingId, formData) => {
	return async function () {
		try {
			const dataResult = await multipartInstance.put(
				`/booking/upload-sou-cancel-screenshot/${BookingId}`,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { message, status } = result;
				if (status) {
					toast.success(message);
					return true;
				} else {
					toast.error(message);
					return false;
				}
			}
		} catch (err) {
			handleErrors(err);
			return false;
		}
	};
};

export const moveBookingToRefund = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/booking/move-to-refund/${_id}`,
				formData
			);
			const { status, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(bookingMoveToRefundSuccess(_id));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const specificCancelMoveToRefund = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/booking/specific-cancel-to-refund/${_id}`,
				formData
			);
			const { status, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(bookingMoveToRefundSuccess(_id));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const refundBooking = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/booking/update-refund-data/${_id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const refundOtherSOUBooking = (_id, formData, setIsPopupOpen, setRefreshData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				`/booking/refund-other-sou-booking/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
					if (setIsPopupOpen) setIsPopupOpen(false);
					if (setRefreshData) setRefreshData(prev => !prev);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const specificRefundBooking = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/booking/update-specific-refund-data/${_id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getAttractionBookingCount = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/booking/get-attraction-booking-count"
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getAttractionBookingCountSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};
export const getPackageBookings = fetchData(
	"booking/getAllPackage",
	getPackageBookingSuccess
);
export const getPackageBookingHistory = fetchData(
	"booking/getBookPackageHistory",
	getPackageBookingSuccess
);
export const getTeam = fetchData("team/getAll", getTeamSuccess);

export const getAllTeam = fetchDataNoPag("team/getAll", getTeamSuccess);

/* Get One Team */
export const getOneTeam = getOneItem("team", getOneTeamSuccess);

/* Add one Team*/
export const setTeam = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/team/addTeamMember",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					navigate("/team");
					toast.success(message);
					dispatch(addTeamSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

/* Update one Team*/
export const updateTeam = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/team/update/${_id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/team");
					toast.success(message);
					dispatch(updateTeamSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateProfile = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/team/update-profile/${_id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateTeamSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

/* Update one Team*/
export const updateTeamStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/team/update-team-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateTeamSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateTeamLoginAccess = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/team/update-login-access/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateTeamSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

// /* Delete one Team */
export const deleteTeam = deleteItem("team", deleteTeamSuccess);

export const addTeamAttendance = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/team/addTeamAttendance",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addTeamAttendanceSuccess(data));
					return status;
				} else {
					toast.error(message);
					return status;
				}
			}
		} catch (err) {
			handleErrors(err);
			return false;
		}
	};
};

export const getTeamAttendance = fetchData(
	"team/getTeamAttendance",
	getTeamAttendanceSuccess
);

export const getTeamAttendanceById = (id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				`/team/fetchTeamAttendanceById/${id}`
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getOneTeamAttendanceSuccess(data));
					return status;
				} else {
					toast.error(message);
					return status;
				}
			}
		} catch (err) {
			handleErrors(err);
			return false;
		}
	};
};

export const editTeamAttendance = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/team/updateTeamAttendance/" + formData._id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateTeamAttendanceSuccess(data));
					return status;
				} else {
					toast.error(message);
					return status;
				}
			}
		} catch (err) {
			handleErrors(err);
			return false;
		}
	};
};

export const getBankAccount = fetchData(
	"accounting/getAll",
	getBankAccountSuccess
);

export const getAllBankAccountData = fetchDataNoPag(
	"accounting/getAllNoPageAccount",
	getBankAccountSuccess
);

export const getOneBankAccount = getOneItem(
	"accounting",
	getOneBankAccountSuccess
);

export const setBankAccount = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/accounting/addBankAccount",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					navigate("/accounting/bank-account");
					toast.success(message);
					dispatch(addBankAccountSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateBankAccount = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/updateBankAccount/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/accounting/bank-account");
					toast.success(message);
					dispatch(updateBankAccountSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateBankAccountStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/update-account-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBankAccountSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteBankAccount = deleteItem(
	"accounting",
	deleteBankAccountSuccess
);

export const getCreditCard = fetchData(
	"accounting/getAllCreditCard",
	getCreditCardSuccess
);

export const getOneCreditCard = getOneItem(
	"accounting",
	getOneCreditCardSuccess
);

export const setCreditCard = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/accounting/addCreditCard",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					navigate("/accounting/credit-card");
					toast.success(message);
					dispatch(addCreditCardSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateCreditCard = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/updateCreditCard/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/accounting/credit-card");
					toast.success(message);
					dispatch(updateCreditCardSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateCreditCardStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/update-account-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateCreditCardSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteCreditCard = deleteItem(
	"accounting",
	deleteCreditCardSuccess
);

const getDebitCategorySuccess = createAction(
	types.GET_ALL_DEBIT_CATEGORY,
	(DebitCategory) => DebitCategory
);

export const getDebitCategory = fetchData(
	"accounting/getAllDebitCategory",
	getDebitCategorySuccess
);

const getOneDebitCategorySuccess = createAction(
	types.GET_ONE_DEBIT_CATEGORY,
	(oneDebitCategory) => oneDebitCategory
);

const addDebitCategorySuccess = createAction(
	types.SET_DEBIT_CATEGORY,
	(DebitCategory) => DebitCategory
);

export const getOneDebitCategory = getOneItem(
	"accounting",
	getOneDebitCategorySuccess
);

export const setDebitCategory = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/accounting/addDebitCategory",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					navigate("/accounting/debit-type");
					toast.success(message);
					dispatch(addDebitCategorySuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateDebitCategory = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/updateDebitCategory/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch({ type: types.UPDATE_DEBIT_CATEGORY, payload: { _id, data } });
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteDebitCategory = deleteItem(
	"accounting",
	types.DELETE_DEBIT_CATEGORY
);

const getCreditCategorySuccess = createAction(
	types.GET_ALL_CREDIT_CATEGORY,
	(CreditCategory) => CreditCategory
);

export const getCreditCategory = fetchData(
	"accounting/getAllCreditCategory",
	getCreditCategorySuccess
);

const getOneCreditCategorySuccess = createAction(
	types.GET_ONE_CREDIT_CATEGORY,
	(oneCreditCategory) => oneCreditCategory
);

const addCreditCategorySuccess = createAction(
	types.SET_CREDIT_CATEGORY,
	(CreditCategory) => CreditCategory
);

export const getOneCreditCategory = getOneItem(
	"accounting",
	getOneCreditCategorySuccess
);

export const setCreditCategory = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/accounting/addCreditCategory",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					navigate("/accounting/credit-type");
					toast.success(message);
					dispatch(addCreditCategorySuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateCreditCategory = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/updateCreditCategory/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch({ type: types.UPDATE_CREDIT_CATEGORY, payload: { _id, data } });
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteCreditCategory = deleteItem(
	"accounting",
	types.DELETE_CREDIT_CATEGORY
);

export const updateCreditCategoryStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/updateCreditCategoryStatus/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch({ type: types.UPDATE_CREDIT_CATEGORY, payload: { _id, data } });
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateDebitCategoryStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/updateDebitCategoryStatus/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch({ type: types.UPDATE_DEBIT_CATEGORY, payload: { _id, data } });
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getAllBankAccount = async () => {
	try {
		const dataResult = await instance.get("/accounting/getAllBankAccount");
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, data, message } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
				return [];
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};
export const getDebitNote = fetchData(
	"accounting/getAllDebitNote",
	getDebitNoteSuccess
);

export const getDebitNoteNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams(params).toString();
		const dataResult = await instance.get(
			`/accounting/getAllDebitNote?${queryParams}`
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { data, message, status } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getOneDebitNote = getOneItem("accounting", getOneDebitNoteSuccess);

export const setDebitNote = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/accounting/addDebitNote",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addDebitNoteSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateDebitNote = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/updateDebitNote/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/accounting/payment");
					toast.success(message);
					dispatch(updateDebitNoteSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateDebitNoteStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/update-account-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateDebitNoteSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteDebitNote = deleteItem("accounting", deleteDebitNoteSuccess);

export const getCreditNote = fetchData(
	"accounting/getAllCreditNote",
	getCreditNoteSuccess
);

export const getOneCreditNote = getOneItem(
	"accounting",
	getOneCreditNoteSuccess
);

export const getCreditNoteNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams(params).toString();
		const dataResult = await instance.get(
			`/accounting/getAllCreditNote?${queryParams}`
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { data, message, status } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getJournalNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams(params).toString();
		const dataResult = await instance.get(
			`/accounting/getAllJournal?${queryParams}`
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { data, message, status } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getReceiptNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams(params).toString();
		const dataResult = await instance.get(
			`/accounting/getAllReceipt?${queryParams}`
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { data, message, status } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getPaymentNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams(params).toString();
		const dataResult = await instance.get(
			`/accounting/getAllPayment?${queryParams}`
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { data, message, status } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getStaffDebitNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams({ ...params, isStaff: 'true' }).toString();
		const dataResult = await instance.get(
			`/accounting/getAllPayment?${queryParams}`
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { data, message, status } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getStaffCreditNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams({ ...params, isStaff: 'true' }).toString();
		const dataResult = await instance.get(
			`/accounting/getAllReceipt?${queryParams}`
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { data, message, status } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getStaffVoucherTotal = (voucherType, date) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				`/accounting/getCrDrTotal?voucherType=${voucherType}&startDate=${date}&isStaff=true`
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getCrDrTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setStaffDebitNote = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/accounting/addStaffDebitNote",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					return true;
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setStaffCreditNote = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/accounting/addStaffCreditNote",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					return true;
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getSales = fetchData("accounting/getAllSales", getSalesSuccess);
export const getSalesNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams(params).toString();
		const dataResult = await instance.get(`/accounting/getAllSales?${queryParams}`);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { data, message, status } = result;
			if (status) return data;
			else toast.error(message);
		}
	} catch (err) { handleErrors(err); }
};

export const getPurchase = fetchData("accounting/getAllPurchase", getPurchaseSuccess);
export const getPurchaseNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams(params).toString();
		const dataResult = await instance.get(`/accounting/getAllPurchase?${queryParams}`);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { data, message, status } = result;
			if (status) return data;
			else toast.error(message);
		}
	} catch (err) { handleErrors(err); }
};

export const setVoucher = (formData, navigate) => {
	return async function (dispatch) {
		try {
			const dataResult = await instance.post("/accounting/addVoucher", formData);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { data, message, status } = result;
				if (status) {
					toast.success(message);
					return true;
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setCreditNote = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/accounting/addCreditNote",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addCreditNoteSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateCreditNote = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/updateCreditNote/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/accounting/receipt");
					toast.success(message);
					dispatch(updateCreditNoteSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateCreditNoteStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/accounting/update-account-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateCreditNoteSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteCreditNote = deleteItem(
	"accounting",
	deleteCreditNoteSuccess
);

export const getOneSiteSetting = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(`/settings/getSiteSetting`);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					dispatch(getOneSiteSettingSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateSiteSetting = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/settings/updateSiteSetting/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(getOneSiteSettingSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getServiceChargesByDate = async (params = {}) => {
	try {
		const query = new URLSearchParams(params).toString();
		const dataResult = await instance.get(`/settings/service-charge-by-date${query ? `?${query}` : ""}`);
		const { status, data, message } = dataResult.data;
		if (dataResult.status === 200) {
			if (status) {
				return data;
			} else {
				toast.error(message);
				return null;
			}
		}
	} catch (err) {
		handleErrors(err);
		return null;
	}
};

export const setServiceChargeByDate = async (formData) => {
	try {
		const dataResult = await instance.post(`/settings/service-charge-by-date`, formData);
		const { status, data, message } = dataResult.data;
		if (dataResult.status === 200) {
			if (status) {
				toast.success(message);
				return true;
			} else {
				toast.error(message);
				return false;
			}
		}
	} catch (err) {
		handleErrors(err);
		return false;
	}
};

export const deleteServiceChargeByDate = async (itemId) => {
	try {
		const dataResult = await instance.delete(`/settings/service-charge-by-date/${itemId}`);
		const { status, message } = dataResult.data;
		if (dataResult.status === 200) {
			if (status) {
				toast.success(message);
				return true;
			} else {
				toast.error(message);
				return false;
			}
		}
	} catch (err) {
		handleErrors(err);
		return false;
	}
};

export const fetchEffectiveServiceCharge = async (date) => {
	try {
		if (!date) return 15;
		let dateStr = date;
		if (date instanceof Date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0");
			const day = String(date.getDate()).padStart(2, "0");
			dateStr = `${year}-${month}-${day}`;
		}
		const dataResult = await instance.get(`/settings/service-charge-by-date?date=${encodeURIComponent(dateStr)}`);
		const { status, data } = dataResult.data || {};
		if (dataResult.status === 200 && status && data) {
			return data.effectiveServiceCharge ?? data.serviceCharge ?? 15;
		}
		return 15;
	} catch (err) {
		return 15;
	}
};

export const getSellsSettlement = async (url = "") => {
	try {
		const dataResult = await instance.get(
			"/accounting/reports/settlement" + url
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, data, message } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
				return [];
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const setSettlement = async (formData) => {
	try {
		const dataResult = await instance.post(
			"/accounting/reports/updateSettlement",
			formData
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, message } = result;
			if (status) {
				toast.success(message);
			} else {
				toast.error(message);
			}
			return status;
		}
	} catch (err) {
		handleErrors(err);
	}
};

const getAllDailySettlementsSuccess = createAction(
	types.GET_ALL_DAILY_SETTLEMENTS,
	(DailySettlement) => DailySettlement
);

const getOneDailySettlementSuccess = createAction(
	types.GET_ONE_DAILY_SETTLEMENT,
	(oneDailySettlement) => oneDailySettlement
);

export const clearOneDailySettlement = () => ({
	type: types.CLEAR_ONE_DAILY_SETTLEMENT,
});

export const getAllDailySettlements = fetchData(
	"accounting/getAllDailySettlements",
	getAllDailySettlementsSuccess
);

export const getOneDailySettlement = (itemId) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(`/accounting/getOneDailySettlement/${itemId}`);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getOneDailySettlementSuccess(data));
					return data;
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPendingRazorpaySettlement = async (url = "") => {
	try {
		const dataResult = await instance.get(
			"/accounting/getPendingRazorpaySettlement" + url
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, data, message } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
				return [];
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const uploadSettlementExcel = async (formData) => {
	try {
		const dataResult = await multipartInstance.post(
			"/accounting/uploadSettlementExcel",
			formData
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, message } = result;
			if (status) {
				toast.success(message);
				return status;
			} else {
				toast.error(message);
				return status;
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getHomeBanner = fetchData(
	"settings/getAllHomeBanner",
	getHomeBannerSuccess
);

export const getOneHomeBanner = getOneItem(
	"settings/homeBanner",
	getOneHomeBannerSuccess
);

export const setHomeBanner = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/settings/update-home-banners",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					if (formData._id) {
						dispatch(updateHomeBannerSuccess(formData._id, data));
					} else {
						dispatch(addHomeBannerSuccess(data));
					}
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteHomeBanner = deleteItem(
	"settings/homeBanner",
	deleteHomeBannerSuccess
);

export const getHomePlace = fetchData(
	"settings/getHomePlaces",
	getHomePlaceSuccess
);

export const getOneHomePlace = getOneItem(
	"settings/homePlace",
	getOneHomePlaceSuccess
);

export const setHomePlace = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/settings/update-home-place",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					if (formData._id) {
						dispatch(updateHomePlaceSuccess(formData._id, data));
					} else {
						dispatch(addHomePlaceSuccess(data));
					}
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteHomePlace = deleteItem(
	"settings/HomePlace",
	deleteHomePlaceSuccess
);

export const getPhoneNumber = fetchData(
	"settings/getAllPhoneNumber",
	getPhoneNumberSuccess
);

export const getAllPhoneNumberData = fetchDataNoPag(
	"settings/getAllNoPagePhoneNumber",
	getPhoneNumberSuccess
);

export const getOnePhoneNumber = getOneItem(
	"settings/phoneNumber",
	getOnePhoneNumberSuccess
);

export const setPhoneNumber = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/settings/addOrUpdatePhoneNumber/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					if (id) {
						dispatch(updatePhoneNumberSuccess(id, data));
					} else {
						dispatch(addPhoneNumberSuccess(data));
					}
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deletePhoneNumber = deleteItem(
	"settings/phoneNumber",
	deletePhoneNumberSuccess
);

export const updatePhoneNumberStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/settings/updatePhoneNumberStatus/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updatePhoneNumberSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getBankAccess = fetchData(
	"team/getAllAssignBank",
	getBankAccessSuccess
);

export const getBankAccessByStaff = fetchData(
	"team/getBankAccessByStaff",
	getBankAccessSuccess
);

export const setBankAccess = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/team/assignBankAccount",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addBankAccessSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateBankAccessStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/team/updateAssignBankStatus/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBankAccessSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setBankAccessByStaff = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/team/assignBankAccountByStaff",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addBankAccessSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getDashboardData = (date, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/dashboard/getData?date=" + date);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getDashboardDataSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getDashboardOtherData = (date, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/dashboard/getOtherData?date=" + date);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getDashboardOtherDataSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPaymentHistoryData = (date, accountDateFilterFromValue, accountDateFilterToValue) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/dashboard/getPaymentHistoryData?date=" + date +
				"&accountDateFilterFromValue=" + accountDateFilterFromValue +
				"&accountDateFilterToValue=" + accountDateFilterToValue
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPaymentHistorySuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getDailyLedgerData = (date) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/dashboard/getDailyLedgerReportData?date=" + date
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getDailyLedgerSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getAccessKeysData = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/team/getAccessKeys");
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getAccessKeysSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const saveStaffAccess = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/team/updateStaffAccess/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateTeamSuccess(id, data));
					return status;
				} else {
					toast.error(message);
					return status;
				}
			}
		} catch (err) {
			handleErrors(err);
			return false;
		}
	};
};

export const getBankTransfer = fetchData(
	"accounting/getAllBankTransfer",
	getBankTransferSuccess
);
export const getBankTransferNoPage = async (params) => {
	try {
		const queryParams = new URLSearchParams(params).toString();
		const dataResult = await instance.get(
			`/accounting/getAllBankTransfer?${queryParams}&paginate=false`
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			return result.data;
		}
	} catch (err) { handleErrors(err); }
};

export const setBankTransfer = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/accounting/addTransferBalanceEntry",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addBankTransferSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getNumberAccess = fetchData(
	"team/getAllAssignNumber",
	getNumberAccessSuccess
);

export const setNumberAccess = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post("/team/assignNumber", formData);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addNumberAccessSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateNumberAccess = async (formData) => {
	try {
		const dataResult = await instance.post(
			"/team/updateAssignNumber",
			formData
		);
		const result = dataResult.data;
		if (dataResult.status === 201 || dataResult.status === 200) {
			const { status, data, message } = result;
			if (status) {
				toast.success(message);
			} else {
				toast.error(message);
			}
			return data;
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const updateNumberAccessStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/team/updateAssignNumberStatus/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateNumberAccessSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getAssignNumberToStaff = async () => {
	try {
		const dataResult = await instance.get("/team/getAssignPhoneNumber");
		const result = dataResult.data;
		if (dataResult.status === 201 || dataResult.status === 200) {
			const { data } = result;
			return data;
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getAssignBankToStaff = async () => {
	try {
		const dataResult = await instance.get("/team/getAssignBankDetail");
		const result = dataResult.data;
		if (dataResult.status === 201 || dataResult.status === 200) {
			const { data } = result;
			return data;
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getPackageBookingCount = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/booking/get-package-booking-count"
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPackageBookingCountSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const confirmUpcomingBooking = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/booking/upcoming-confirm/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const rejectUpcomingBooking = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/booking/upcoming-reject/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const confirmERikshawBooking = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/booking/erikshaw-confirm/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const confirmERikshawBookingFromSOU = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/booking/erikshaw-confirm-sou/" + id
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const specificCancelBooking = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				`/booking/specificCancel/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(getOneBookingSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const cancelUpcomingAttraction = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				`/booking/cancel-upcoming-attraction/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(getOneBookingSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const checkSlotForAttraction = async (formData) => {
	try {
		const dataResult = await instance.post(`/quotation/check-slot`, formData);
		const { status, data, message } = dataResult.data;
		if (dataResult.status === 200) {
			if (!status) {
				toast.error(message);
			}
			return data;
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getCountries = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/user/countries");
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getCountriesSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getStates = (id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/user/state/" + id);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getStatesSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getQuotations = fetchData("quotation/getAll", getQuotationSuccess);

export const setQuotation = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/quotation/createQuotation",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					navigate("/quotation/action/" + data.quotationId);
					toast.success(message);
					dispatch(addQuotationSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateQuotation = (id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/quotation/updateQuotation/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					navigate("/quotations/pending");
					toast.success(message);
					dispatch(updateQuotationSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getOneQuotation = getOneItem("quotation", getOneQuotationSuccess);

export const getVisitor = fetchData(
	"quotation/getAllVisitor",
	getVisitorSuccess
);

export const getAllVisitor = (id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/quotation/getAllNoPageVisitor/" + id
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getVisitorSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setVisitor = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/quotation/addVisitor/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					dispatch(addVisitorSuccess(data));
					toast.success(message);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateVisitor = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/quotation/updateVisitor/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(updateVisitorSuccess(formData._id, data));
					toast.success(message);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteVisitor = deleteItem("quotation", deleteVisitorSuccess);

export const confirmQuotationBooking = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/quotation/confirm/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateQuotationSuccess(id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const rejectQuotationBooking = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/quotation/reject/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateQuotationSuccess(id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getTeamBankReport = fetchData(
	"team/getTeamBankReport",
	getTeamBankReportSuccess
);

export const getStaffSalesReport = (url) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/team/getStaffSalesReport?" + url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, meta, message } = result;
				if (status) {
					dispatch(getStaffSalesReportSuccess(data));
					dispatch(getStaffSalesDataSuccess(meta));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const assignBookingToStaff = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/booking/assignBooking/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setNotBookingFlag = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/booking/notBooking/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const mackOnlyErikshawBooking = (_id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/booking/mack-only-erikshaw/${_id}`
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPackageImage = (_id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/package/allImages/" + _id);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPackageImageSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setPackageImages = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/package/upload-images/" + _id,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addPackageImageSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPackageVideo = (_id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/package/allVideos/" + _id);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPackageVideoSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setPackageVideo = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/package/upload-videos/" + _id,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addPackageVideoSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPackageReels = (_id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/package/allReels/" + _id);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPackageReelsSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setPackageReels = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/package/upload-reels/" + _id,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addPackageReelsSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deletePackageGalleryItem = (_id, type) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/package/remove-gallery/" + _id + "?type=" + type
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, message } = result;
				if (status) {
					toast.success(message);
					if (type === "image") {
						dispatch(deletePackageImageSuccess(_id));
					} else if (type === "video") {
						dispatch(deletePackageVideoSuccess(_id));
					} else {
						dispatch(deletePackageReelsSuccess(_id));
					}
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getTeamSalaryReport = (date, staffId = "") => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/team/getTeamSalaryReport?startDate=" + date + "&staffId=" + staffId
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getTeamTeamSalaryReportSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getEnquiry = fetchData("enquiry/getAll", getEnquirySuccess);

export const getConfirmEnquiry = fetchData(
	"enquiry/getAllComplete",
	getEnquirySuccess
);

export const updateEnquiry = (
	_id,
	formData,
	setToggleMenu,
	toggleMenu
) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/enquiry/update/${_id}`, formData);
			const { status, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					if (formData.enquiryStatus !== 'enquiry') {
						dispatch(deleteEnquirySuccess(_id));
					}
					setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

// export const getPlaceBookingOffSetting = (id) => fetchData(
// 	"place/place-booking-off/"+id,
// 	getPlaceBookingOffSettingSuccess
// );

export const getPlaceBookingOffSetting = fetchData(
	"place/place-booking-off",
	getPlaceBookingOffSettingSuccess
);

export const setPlaceBookingOffSetting = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/place/add-booking-off",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201) {
				const { status, data, message } = result;
				if (status) {
					dispatch(addPlaceBookingOffSettingSuccess(data));
					navigate("/place/off");
					toast.success(message);
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deletePlaceBookingOffSetting = deleteItem(
	"place/place-booking-setting",
	deletePlaceBookingOffSettingSuccess
);

export const setPackageSortOrder = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put("/package/setSortOrder", formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPackageSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const setPackageCategorySortOrder = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put("/category/setSortOrder", formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getPackageCategorySuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getHomePageNote = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/settings/getHomeNote");
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getOneHomePageNoteSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateHomeNote = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/settings/updateHomeNote/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(getOneHomePageNoteSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPlaceKeys = fetchData(
	"settings/getPlaceKey",
	getPlaceKeySuccess
);

export const getFaq = fetchData("faq/getAll", getFaqSuccess);

export const getOneFaq = getOneItem("faq", getOneFaqSuccess);

export const setFaq = (id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/faq/addOrUpdateFaq/" + id,
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					if (id) {
						dispatch(updateFaqSuccess(id, data));
					} else {
						dispatch(addFaqSuccess(data));
					}
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteFaq = deleteItem("faq", deleteFaqSuccess);

export const getWarningMessage = (id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/settings/get-waning-message");
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getWarningMessageSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getAvailableTickets = fetchData(
	"place/getAllAvailableTickets",
	getAvailableTicketSuccess
);

export const getAvailableTicketBySlot = async (endpoint) => {
	try {
		const responseResult = await instance.get(endpoint);
		const { status, data, message } = responseResult.data;
		if (responseResult.status === 200) {
			if (status) {
				return data;
			} else {
				if (message) toast.error(message);
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getNotificationCount = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/notification/get-unread-notification-count"
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getNotificationCountSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getAllNotifications = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/notification/get-notifications");
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getNotificationSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const notificationMarkAsRead = (id) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/notification/notification-mark-as-read/" + id
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getNotificationCountSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const markAllNotificationRead = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/notification/mark-all-notification-read"
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getNotificationCountSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

// /* Delete Multiple Hotel */
// export const deleteMultipleHotel = deleteMultipleItem(
// 	"hotel",
// 	deleteMultipleHotelSuccess
// );

/* Delete-Undo one Place */
// export const deleteUndoPlace = deleteItem("place", deletePlaceSuccess, true);

export const saveStaffSalary = (formData, salaryMonth, staffId) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post("/team/saveStaffSalary", formData);
			const result = dataResult.data;
			if (dataResult.status === 200 || dataResult.status === 201) {
				const { status, message } = result;
				if (status) {
					toast.success(message);
					dispatch(getTeamSalaryReport(salaryMonth, staffId));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getBookingSettings = async (date) => {
	try {
		const query = date ? `?date=${encodeURIComponent(date)}` : "";
		const dataResult = await instance.get(`/booking/get-booking-settings${query}`);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, data, message } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
				return [];
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const fetchHotelProfile = fetchDataNoPag(
	"hotel/getAllNoPageHotel",
	getHotelSuccess
);

export const rejectMultipleUpcomingBooking = async (formData) => {
	try {
		const dataResult = await instance.put(
			"/booking/multiple-upcoming-reject",
			formData
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, message } = result;
			if (status) {
				toast.success(message);
			} else {
				toast.error(message);
			}
			return status;
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getCrDrTotal = (type, date) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/accounting/getCrDrTotal?transactionType=" +
				type +
				"&startDate=" +
				date
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getCrDrTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getVoucherTotal = (voucherType, date) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/accounting/getCrDrTotal?voucherType=" +
				voucherType +
				"&startDate=" +
				date
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getCrDrTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getLedgersBySubGroup = async () => {
	try {
		const dataResult = await instance.get(`/tally/ledger-by-subgroup`);
		if (dataResult.status === 200) {
			return dataResult.data.data;
		}
	} catch (err) { handleErrors(err); }
};

export const getBankTransferTotal = (date) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				"/accounting/getCrDrTotal?voucherType=contra&startDate=" +
				date
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getCrDrTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const gerSalarySlip = async (staffId, date) => {
	try {
		const dataResult = await instance.get(
			"/team/getSalarySlip?staffId=" + staffId + "&startDate=" + date
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, data, message } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
			}
			return status;
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getOneHotelSetting = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(`/settings/getHotelSettings`);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					dispatch(getOneHotelSettingSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateHotelSettings = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/settings/updateHotelSettings`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(getOneHotelSettingSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getCurrentBalanceTotal = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/accounting/getTotalCurrentBalance");
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getCurrentBalanceTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateHotelAdminSettings = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/settings/updateHotelAdminSettings`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(getOneHotelSettingSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getTestimonial = fetchData(
	"testimonial/getAll",
	getTestimonialSuccess
);

export const getOneTestimonial = getOneItem(
	"testimonial",
	getOneTestimonialSuccess
);

export const setTestimonial = (id, formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post("/testimonial/add", formData);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addTestimonialSuccess(data));
					setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteTestimonial = deleteItem(
	"testimonial",
	deleteTestimonialSuccess
);

export const updateTestimonial = (id, formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/testimonial/update/${id}`, formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateTestimonialSuccess(data));
					setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getSalesReport = fetchData("report/sales", getSalesReportSuccess);
export const getSalesReportExport = (startDate, endDate, type) => {
	return async function (dispatch) {
		try {
			let url = "/report/salesForExport?startDate=" + startDate + "&endDate=" + endDate;
			if (type) {
				url += "&type=" + type;
			}
			const dataResult = await instance.get(url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getSalesReportExportSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getSalesReportTotal = (startDate, endDate, type) => {
	return async function (dispatch) {
		try {
			let url = "/report/totalOfSales?startDate=" + startDate + "&endDate=" + endDate;
			if (type) {
				url += "&type=" + type;
			}
			const dataResult = await instance.get(url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getSalesReportTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPurchaseReport = fetchData("report/purchase", getPurchaseReportSuccess);
export const getPurchaseReportExport = (startDate, endDate) => {
	return async function (dispatch) {
		try {
			const dataResult = await instance.get("/report/purchaseForExport?startDate=" + startDate + "&endDate=" + endDate);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getPurchaseReportExportSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getPurchaseReportTotal = (startDate, endDate) => {
	return async function (dispatch) {
		try {
			const dataResult = await instance.get("/report/totalOfPurchase?startDate=" + startDate + "&endDate=" + endDate);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getPurchaseReportTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getCommissionReport = fetchData("report/commission", getCommissionReportSuccess);
export const getCommissionReportExport = (startDate, endDate) => {
	return async function (dispatch) {
		try {
			const dataResult = await instance.get("/report/commissionForExport?startDate=" + startDate + "&endDate=" + endDate);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getCommissionReportExportSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getCommissionReportTotal = (startDate, endDate) => {
	return async function (dispatch) {
		try {
			const dataResult = await instance.get("/report/totalOfCommission?startDate=" + startDate + "&endDate=" + endDate);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getCommissionReportTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getCancelReport = fetchData("report/cancel", getCancelReportSuccess);
export const getCancelReportExport = (startDate, endDate) => {
	return async function (dispatch) {
		try {
			const dataResult = await instance.get("/report/cancelForExport?startDate=" + startDate + "&endDate=" + endDate);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getCancelReportExportSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getCancelReportTotal = (startDate, endDate) => {
	return async function (dispatch) {
		try {
			const dataResult = await instance.get("/report/totalOfCancel?startDate=" + startDate + "&endDate=" + endDate);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getCancelReportTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getAttractionReport = fetchData("report/attraction", getAttractionReportSuccess);

export const getAttractionReportExport = (startDate, endDate, search) => {
	return async function (dispatch) {
		try {
			let url = "/report/attractionForExport?startDate=" + startDate + "&endDate=" + endDate;
			if (search) {
				url += "&search=" + search;
			}
			const dataResult = await instance.get(url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getAttractionReportExportSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getAttractionReportTotal = (startDate, endDate, search) => {
	return async function (dispatch) {
		try {
			let url = "/report/totalOfAttraction?startDate=" + startDate + "&endDate=" + endDate;
			if (search) {
				url += "&search=" + search;
			}
			const dataResult = await instance.get(url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getAttractionReportTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getBookingForReview = fetchData("report/get-bookings-for-review", getBookingForReviewSuccess);

export const getGstReport = fetchData("report/gst", getGstReportSuccess);

export const getGstReportExport = (startDate, endDate, type) => {
	return async function (dispatch) {
		try {
			let url = "/report/gstForExport?startDate=" + startDate + "&endDate=" + endDate;
			if (type) {
				url += "&type=" + type;
			}
			const dataResult = await instance.get(url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getGstReportExportSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getGstReportTotal = (startDate, endDate, type) => {
	return async function (dispatch) {
		try {
			let url = "/report/totalOfGst?startDate=" + startDate + "&endDate=" + endDate;
			if (type) {
				url += "&type=" + type;
			}
			const dataResult = await instance.get(url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data, status, message } = result;
				if (status) {
					dispatch(getGstReportTotalSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const fetchOneHotelRoomCount = async (
	slug,
	checkInDate,
	checkOutDate,
	roomCount,
	hotelId,
	complimentaryId
) => {
	try {
		const endpoint = `hotel/checkRoomAvailability/${slug}?checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&roomCount=${roomCount}&hotelId=${hotelId}&complimentaryId=${complimentaryId}`;
		const responseResult = await instance.get(endpoint);
		const result = responseResult.data;
		if (responseResult.status) {
			const { data } = result;
			return data;
		}
	} catch (error) {
		handleErrors(error);
	}
};

export const sendTicketViaWhatsapp = (_id) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.get(`/booking/send-to-whatsapp/${_id}`);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (!status) {
					toast.error(message);
				} else {
					dispatch(updateBookingSuccess(_id, data));
					toast.success(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	}
};

export const updateJumpedBookingState = (_id, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get(
				`/booking/fix-status/${_id}`,
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
					navigate("/attraction-booking/pending");
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const sendReviewMessage = async (formData) => {
	try {
		const dataResult = await instance.put(
			"/report/send-review-message",
			formData
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, message } = result;
			if (status) {
				toast.success(message);
			} else {
				toast.error(message);
			}
			return status;
		}
	} catch (err) {
		handleErrors(err);
	}
};

// ============ BLOG CATEGORY ACTIONS (Matching Package Category Pattern) ============

// Success action creators
const getBlogCategorySuccess = createAction(
	types.GET_ALL_BLOG_CATEGORY,
	(BlogCategory) => BlogCategory
);

const getOneBlogCategorySuccess = createAction(
	types.GET_ONE_BLOG_CATEGORY,
	(oneBlogCategory) => oneBlogCategory
);

export const clearBlogCategory = () => ({
	type: types.CLEAR_ONE_BLOG_CATEGORY,
});

const addBlogCategorySuccess = createAction(
	types.SET_BLOG_CATEGORY,
	(BlogCategory) => BlogCategory
);

const updateBlogCategorySuccess = (
	BlogCategoryId,
	UpdatedBlogCategory
) => ({
	type: types.UPDATE_BLOG_CATEGORY,
	payload: { BlogCategoryId, UpdatedBlogCategory },
});

const deleteBlogCategorySuccess = createAction(
	types.DELETE_BLOG_CATEGORY,
	(BlogCategoryId) => ({
		BlogCategoryId,
	})
);

// Async actions
export const getBlogCategory = fetchData(
	"blogCategory/getall",
	getBlogCategorySuccess
);

export const getAllBlogCategory = fetchDataNoPag(
	"blogCategory/allCategory",
	getBlogCategorySuccess
);

export const getOneBlogCategory = getOneItem(
	"blogCategory",
	getOneBlogCategorySuccess
);

export const setBlogCategory = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/blogCategory/add",
				formData,
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					navigate("/blog/category");
					toast.success(message);
					dispatch(addBlogCategorySuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateBlogCategory = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/blogCategory/update/${_id}`,
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/blog/category");
					toast.success(message);
					dispatch(updateBlogCategorySuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateBlogCategoryStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/blogCategory/update-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBlogCategorySuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteBlogCategory = deleteItem(
	"blogCategory",
	deleteBlogCategorySuccess
);

export const setBlogCategorySortOrder = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put("/blogCategory/setSortOrder", formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getBlogCategorySuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

// ============ BLOG ACTIONS (Matching Package Pattern) ============

// Success action creators
const getBlogSuccess = createAction(
	types.GET_ALL_BLOG,
	(Blog) => Blog
);

const getOneBlogSuccess = createAction(
	types.GET_ONE_BLOG,
	(oneBlog) => oneBlog
);

export const clearBlog = () => ({
	type: types.CLEAR_ONE_BLOG,
});

const addBlogSuccess = createAction(types.SET_BLOG, (Blog) => Blog);

const updateBlogSuccess = (BlogId, UpdatedBlog) => ({
	type: types.UPDATE_BLOG,
	payload: { BlogId, UpdatedBlog },
});

const deleteBlogSuccess = createAction(
	types.DELETE_BLOG,
	(BlogId) => ({
		BlogId,
	})
);

// Async actions
export const getBlog = fetchData("blog/getall", getBlogSuccess);

export const getAllBlogs = fetchDataNoPag(
	"blog/getAllBlog",
	getBlogSuccess
);

export const getOneBlog = getOneItem("blog", getOneBlogSuccess);

export const setBlog = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.post(
				"/blog/add",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					navigate("/blog/list");
					toast.success(message);
					dispatch(addBlogSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateBlog = (_id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await multipartInstance.put(
				`/blog/update/${_id}`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					navigate("/blog/list");
					toast.success(message);
					dispatch(updateBlogSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateBlogStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(
				`/blog/update-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBlogSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteBlog = deleteItem("blog", deleteBlogSuccess);

export const setBlogSortOrder = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put("/blog/setSortOrder", formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getBlogSuccess(data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateSOUBookingStatus = (_id, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				`/booking/check-sou-status/${_id}`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(_id, data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateSlots = async () => {
	try {
		const dataResult = await instance.get(
			`/place/update-availability`,
		);
		const { status, message } = dataResult.data;
		if (dataResult.status === 200) {
			if (status) {
				toast.success(message);
			} else {
				toast.error(message);
			}
			return status;
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const updateOfflineSlots = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				`/place/update-offline-slot`,
				formData
			);
			const { status, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const generateSouPayment = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				`/booking/generate-sou-payment`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (!status && message) {
					toast.error(message);
				}
				return { status, data };
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const confirmSouBooking = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				`/booking/confirm-sou-booking`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBookingSuccess(formData.bookingId, data));
				} else {
					toast.error(message);
				}
				return { status, data };
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const moveToRefunManually = async (_id, formData) => {
	try {
		const dataResult = await instance.post(
			"/booking/move-to-refund-manually/" + _id,
			formData
		);
		const { status, message } = dataResult.data;
		if (dataResult.status === 200) {
			if (status) {
				toast.success(message);
			} else {
				toast.error(message);
			}
			return status;
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const generateSouPreview = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				`/booking/generate-sou-preview`,
				formData
			);
			const { status, data, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (!status && message) {
					toast.error(message);
				}
				return { status, data };
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const closeStaffBankAccount = (formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				"/team/closeStaffBankAccount",
				formData
			);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, message } = result;
				if (status) {
					toast.success(message);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getStaffBankReport = (url) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.get("/team/getTeamBankDetailReport?" + url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					dispatch(getStaffBankDetailDataSuccess(data));
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

// Blog Comment Actions
export const getBlogCommentSuccess = createAction(types.GET_ALL_BLOG_COMMENT, (BlogComment) => BlogComment);
export const addBlogCommentSuccess = createAction(types.SET_BLOG_COMMENT, (BlogComment) => BlogComment);
export const updateBlogCommentSuccess = (BlogCommentId, UpdatedBlogComment) => ({
	type: types.UPDATE_BLOG_COMMENT,
	payload: { BlogCommentId, UpdatedBlogComment },
});
export const deleteBlogCommentSuccess = createAction(types.DELETE_BLOG_COMMENT, (BlogCommentId) => ({
	BlogCommentId,
}));

export const getBlogComment = fetchData("blog/comment/getAll", getBlogCommentSuccess);

export const setBlogComment = (formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post("/blog/comment/add", formData);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addBlogCommentSuccess(data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateBlogComment = (id, formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/blog/comment/update/${id}`, formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateBlogCommentSuccess(id, data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateBlogCommentStatus = (_id, blogId, formData) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/blog/comment/${blogId}/${_id}/status`, formData);
			const { data, message, status } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
					dispatch(updateBlogCommentSuccess(_id, data));
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteBlogComment = deleteItem("blog/comment", deleteBlogCommentSuccess);

// Tally Actions
export const getTallyMainGroupsSuccess = createAction(types.GET_ALL_TALLY_MAIN_GROUP, (MainGroup) => MainGroup);
export const addTallyMainGroupSuccess = createAction(types.SET_TALLY_MAIN_GROUP, (MainGroup) => MainGroup);
export const updateTallyMainGroupSuccess = (AccountMainGroupId, UpdatedAccountMainGroup) => ({
	type: types.UPDATE_TALLY_MAIN_GROUP,
	payload: { AccountMainGroupId, UpdatedAccountMainGroup },
});
export const deleteTallyMainGroupSuccess = createAction(types.DELETE_TALLY_MAIN_GROUP, (AccountMainGroupId) => ({
	AccountMainGroupId,
}));

export const getTallyMainGroups = fetchData("tally/main-group", getTallyMainGroupsSuccess);
export const getTallyMainGroupsNoPag = fetchDataNoPag("tally/main-group", getTallyMainGroupsSuccess);

export const setTallyMainGroup = (formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post("/tally/main-group", formData);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addTallyMainGroupSuccess(data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateTallyMainGroup = (id, formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/tally/main-group/${id}`, formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateTallyMainGroupSuccess(id, data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteTallyMainGroup = deleteItem("tally/main-group", deleteTallyMainGroupSuccess);

export const getTallySubGroupsSuccess = createAction(types.GET_ALL_TALLY_SUB_GROUP, (SubGroup) => SubGroup);
export const addTallySubGroupSuccess = createAction(types.SET_TALLY_SUB_GROUP, (SubGroup) => SubGroup);
export const updateTallySubGroupSuccess = (AccountSubGroupId, UpdatedAccountSubGroup) => ({
	type: types.UPDATE_TALLY_SUB_GROUP,
	payload: { AccountSubGroupId, UpdatedAccountSubGroup },
});
export const deleteTallySubGroupSuccess = createAction(types.DELETE_TALLY_SUB_GROUP, (AccountSubGroupId) => ({
	AccountSubGroupId,
}));

export const getTallySubGroups = fetchData("tally/sub-group", getTallySubGroupsSuccess);

export const setTallySubGroup = (formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post("/tally/sub-group", formData);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addTallySubGroupSuccess(data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateTallySubGroup = (id, formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/tally/sub-group/${id}`, formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateTallySubGroupSuccess(id, data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteTallySubGroup = deleteItem("tally/sub-group", deleteTallySubGroupSuccess);

export const getTallyLedgersSuccess = createAction(types.GET_ALL_TALLY_LEDGER, (Ledger) => Ledger);
export const addTallyLedgerSuccess = createAction(types.SET_TALLY_LEDGER, (Ledger) => Ledger);
export const updateTallyLedgerSuccess = (AccountLedgerId, UpdatedAccountLedger) => ({
	type: types.UPDATE_TALLY_LEDGER,
	payload: { AccountLedgerId, UpdatedAccountLedger },
});
export const deleteTallyLedgerSuccess = createAction(types.DELETE_TALLY_LEDGER, (AccountLedgerId) => ({
	AccountLedgerId,
}));

export const getTallyLedgers = fetchData("tally/ledger", getTallyLedgersSuccess);

export const setTallyLedger = (formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post("/tally/ledger", formData);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addTallyLedgerSuccess(data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateTallyLedger = (id, formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/tally/ledger/${id}`, formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateTallyLedgerSuccess(id, data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteTallyLedger = deleteItem("tally/ledger", deleteTallyLedgerSuccess);

export const updateLedgerOpeningBalance = (id, formData, onSuccess) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/tally/ledger/update-opening-balance/${id}`, formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateTallyLedgerSuccess(id, data));
					if (onSuccess) onSuccess();
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getTallyBalanceSheet = (startDate, endDate) => {
	return async function (dispatch) {
		try {
			let url = "/tally/balance-sheet";
			if (startDate && endDate) {
				url += `?startDate=${startDate}&endDate=${endDate}`;
			}
			const dataResult = await instance.get(url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data } = result;
				dispatch({
					type: types.GET_TALLY_BALANCE_SHEET,
					payload: data,
				});
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getTallyAccountMonthlySnapshots = (accountId, fyYear) => {
	return async function (dispatch) {
		try {
			const res = await instance.get(`/tally/account-monthly-snapshots/${accountId}?fyYear=${fyYear}`);
			return res.data;
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const getTallyAccountVouchers = (accountId, startDate, endDate) => {
	return async function (dispatch) {
		try {
			const res = await instance.get(`/tally/account-transactions/${accountId}?startDate=${startDate}&endDate=${endDate}`);
			return res.data;
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateTallyVoucher = (itemId, formData) => {
	return async function (dispatch) {
		try {
			const res = await instance.put(`/accounting/updateVoucher/${itemId}`, formData);
			if (res.data.status) {
				toast.success(res.data.message);
				return res.data;
			} else {
				toast.error(res.data.message);
				return res.data;
			}
		} catch (err) {
			handleErrors(err);
			throw err;
		}
	};
};

export const deleteTallyVoucher = (itemId) => {
	return async function (dispatch) {
		try {
			const res = await instance.delete(`/accounting/deleteVoucher/${itemId}`);
			if (res.data.status) {
				toast.success(res.data.message);
				return res.data;
			} else {
				toast.error(res.data.message);
				return res.data;
			}
		} catch (err) {
			handleErrors(err);
			throw err;
		}
	};
};

export const getTallyProfitLoss = (startDate, endDate) => {
	return async function (dispatch) {
		try {
			let url = "/tally/profit-and-loss";
			if (startDate && endDate) {
				url += `?startDate=${startDate}&endDate=${endDate}`;
			}
			const dataResult = await instance.get(url);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { data } = result;
				dispatch({
					type: types.GET_TALLY_PROFIT_LOSS,
					payload: data,
				});
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};


export const getPenddingDailySettlement = async () => {
	try {
		const dataResult = await instance.get(
			"/accounting/penddingDailySettlement"
		);
		const result = dataResult.data;
		if (dataResult.status === 200) {
			const { status, data, message } = result;
			if (status) {
				return data;
			} else {
				toast.error(message);
				return [];
			}
		}
	} catch (err) {
		handleErrors(err);
	}
};

export const getAutoAccountEntrySettings = () => {
	return async function (dispatch) {
		try {
			const res = await instance.get("/accounting/getAllAutoAccountEntrySetting");
			if (res.data.status) {
				dispatch({
					type: types.GET_AUTO_ACCOUNT_ENTRY_SETTING,
					payload: res.data.data,
				});
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateAutoAccountEntrySetting = (data) => {
	return async function (dispatch) {
		try {
			const res = await instance.post(
				"/accounting/addAutoAccountEntrySetting",
				data
			);
			if (res.data.status) {
				toast.success(res.data.message);
				dispatch({
					type: types.UPDATE_AUTO_ACCOUNT_ENTRY_SETTING,
					payload: res.data.data,
				});
			} else {
				toast.error(res.data.message);
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

// ─── OPTIONAL ATTRACTION ───────────────────────────────────────────────────

const getOptionalAttractionSuccess = createAction(
	types.GET_ALL_OPTIONAL_ATTRACTION,
	(OptionalAttraction) => OptionalAttraction
);
const addOptionalAttractionSuccess = createAction(
	types.SET_OPTIONAL_ATTRACTION,
	(OptionalAttraction) => OptionalAttraction
);
const updateOptionalAttractionSuccess = (OptionalAttractionId, UpdatedOptionalAttraction) => ({
	type: types.UPDATE_OPTIONAL_ATTRACTION,
	payload: { OptionalAttractionId, UpdatedOptionalAttraction },
});
const deleteOptionalAttractionSuccess = createAction(
	types.DELETE_OPTIONAL_ATTRACTION,
	(OptionalAttractionId) => ({ OptionalAttractionId })
);

export const getOptionalAttractions = fetchData(
	"optional-attraction/getAll",
	getOptionalAttractionSuccess
);

export const getAllOptionalAttractionsNoPag = fetchDataNoPag(
	"optional-attraction/getAllNoPag",
	getOptionalAttractionSuccess
);

export const setOptionalAttraction = (formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post("/optional-attraction/add", formData);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addOptionalAttractionSuccess(data));
					if (navigate) navigate("/optional-attractions");
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateOptionalAttraction = (id, formData, navigate) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/optional-attraction/update/${id}`, formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateOptionalAttractionSuccess(id, data));
					if (navigate) navigate("/optional-attractions");
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteOptionalAttraction = deleteItem(
	"optional-attraction",
	deleteOptionalAttractionSuccess
);
export const updateOptionalAttractionStatus = updateStatus(
	"optional-attraction",
	updateOptionalAttractionSuccess
);

const getOneOptionalAttractionSuccess = createAction(
	types.GET_ONE_OPTIONAL_ATTRACTION,
	(oneOptionalAttraction) => oneOptionalAttraction
);

export const getOneOptionalAttraction = getOneItem(
	"optional-attraction",
	getOneOptionalAttractionSuccess
);

export const clearOneOptionalAttraction = () => ({
	type: types.CLEAR_ONE_OPTIONAL_ATTRACTION,
});

// ─── SITEMAP ──────────────────────────────────────────────────────────────────

const getSitemapsSuccess = createAction(
	types.GET_ALL_SITEMAP,
	(Sitemaps) => Sitemaps
);
const addSitemapSuccess = createAction(
	types.SET_SITEMAP,
	(Sitemap) => Sitemap
);
const updateSitemapSuccess = (SitemapId, UpdatedSitemap) => ({
	type: types.UPDATE_SITEMAP,
	payload: { SitemapId, UpdatedSitemap },
});
const deleteSitemapSuccess = createAction(
	types.DELETE_SITEMAP,
	(SitemapId) => ({ SitemapId })
);

export const getSitemap = fetchData(
	"sitemap/getAll",
	getSitemapsSuccess
);

export const setSitemap = (_id, formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post("/sitemap/add", formData);
			const result = dataResult.data;
			if (dataResult.status === 201 || dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(addSitemapSuccess(data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const updateSitemap = (id, formData, setToggleMenu, toggleMenu) => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.put(`/sitemap/update/${id}`, formData);
			const result = dataResult.data;
			if (dataResult.status === 200) {
				const { status, data, message } = result;
				if (status) {
					toast.success(message);
					dispatch(updateSitemapSuccess(id, data));
					if (setToggleMenu) setToggleMenu(!toggleMenu);
				} else {
					toast.error(message);
				}
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};

export const deleteSitemap = deleteItem(
	"sitemap",
	deleteSitemapSuccess
);

const getOneSitemapSuccess = createAction(
	types.GET_ONE_SITEMAP,
	(oneSitemap) => oneSitemap
);

export const getOneSitemap = getOneItem(
	"sitemap",
	getOneSitemapSuccess
);

export const clearSitemap = () => ({
	type: types.CLEAR_ONE_SITEMAP,
});

export const updateAllBankLedgerBalances = () => {
	return async (dispatch) => {
		try {
			const dataResult = await instance.post(
				`/accounting/updateAllBankLedgerBalances`
			);
			const { status, message } = dataResult.data;
			if (dataResult.status === 200) {
				if (status) {
					toast.success(message);
				} else {
					toast.error(message);
				}
				return status;
			}
		} catch (err) {
			handleErrors(err);
		}
	};
};
